import React from 'react';
import { containerClass, ContactCta, Eyebrow, leadClass, sectionTitleClass } from './ui';

const trainings = [
  {
    title: 'Segelflugausbildung (GPL)',
    intro: 'Erfahren Sie mehr über die Ausbildung zum Segelflugpiloten und den Erwerb des Luftfahrerscheins GPL.',
    blocks: [
      { heading: 'Voraussetzungen', items: ['Medizinische Tauglichkeit', 'Mindestalter 14 Jahre'] },
      {
        heading: 'Ablauf der Ausbildung',
        items: [
          'Theoretische Ausbildung (60 Stunden im Winter, Themen wie Aerodynamik, Navigation)',
          'Praktische Ausbildung (60 Flüge mit Fluglehrer, erster Alleinflug)',
        ],
      },
      { heading: 'Prüfungen und Abschluss', items: ['Theoretische/praktische Prüfung bei der Bezirksregierung', '50 km Überlandflug'] },
      {
        heading: 'Dauer & Weiteres',
        items: ['2–3 Jahre', 'Flugsaison März–Oktober', 'Segelflug als Mannschaftssport', 'Beiträge/Wartungsdienste', 'Fliegen bei Schönwetter'],
      },
    ],
  },
  {
    title: 'Sportpilotenlizenz (SPL) für Ultraleichtflugzeuge',
    intro: 'Erfahren Sie, wie Sie die Sportpilotenlizenz (SPL) erwerben und Ultraleichtflugzeuge fliegen können.',
    blocks: [
      {
        heading: 'Voraussetzungen',
        items: ['Medizinische Tauglichkeit (Medical LAPL/Klasse 2)', 'Mindestalter 16 Jahre', 'Soft Skills', 'Sofortmaßnahmen-Unterricht'],
      },
      {
        heading: 'Ablauf der Ausbildung',
        items: [
          'Theoretische Ausbildung (60 Stunden, Themen wie Luftrecht, Navigation)',
          'Praktische Ausbildung (30 Flugstunden, 5 Alleinflug)',
          'Funksprechzeugnis (BZF II/I)',
        ],
      },
      { heading: 'Nach der Ausbildung', items: ['Praktische Prüfung', 'Frist von 24 Monaten nach Theorieprüfung'] },
      {
        heading: 'Weitere Punkte',
        items: ['Nationale Lizenz', 'Maximales Abfluggewicht 600 kg', 'Kosten 3.500–5.000 Euro, je nach Lernfortschritt', 'Mind. 6 Flugstunden/Jahr'],
      },
    ],
  },
];

const Training: React.FC = () => {
  return (
    <section id="ausbildung" className="border-t border-gray-200 bg-gray-50">
      <div className={`${containerClass} py-10 lg:py-[72px]`}>
        <div className="mb-6 lg:mb-9 lg:grid lg:grid-cols-[5fr_7fr] lg:items-end lg:gap-16">
          <div>
            <Eyebrow>Ausbildung</Eyebrow>
            <h2 className={sectionTitleClass}>Ihre Flugausbildung bei uns</h2>
          </div>
          <p className={`${leadClass} mt-3 lg:mt-0 lg:max-w-[56ch]`}>
            Wir bieten professionelle Ausbildungen für verschiedene Fluglizenzen an. Lernen Sie bei erfahrenen Fluglehrern und starten Sie Ihre Karriere in der Luftfahrt.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-2 lg:gap-8">
          {trainings.map((training) => (
            <article key={training.title} className="border-t-2 border-gray-900 bg-white px-[18px] pb-5 pt-[18px] lg:px-6 lg:pb-7 lg:pt-6">
              <h3 className="mb-2 text-[19px] font-extrabold tracking-[-0.01em] lg:mb-2.5 lg:text-2xl">{training.title}</h3>
              <p className="mb-3.5 text-[15px] leading-normal text-gray-600 lg:mb-[18px]">{training.intro}</p>
              <div className="grid gap-3.5 sm:grid-cols-2 sm:gap-x-6 lg:gap-y-[18px]">
                {training.blocks.map((block) => (
                  <div key={block.heading} className="border-t border-gray-200 pt-2.5">
                    <h4 className="mb-1.5 text-xs font-semibold uppercase tracking-[0.08em] text-blue-600">{block.heading}</h4>
                    <ul className="flex flex-col gap-1">
                      {block.items.map((item) => (
                        <li key={item} className="text-sm leading-[1.45] text-gray-700">
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>

        <ContactCta className="mt-6 lg:mt-8">Starten Sie Ihre Ausbildung noch heute! Kontaktieren Sie uns.</ContactCta>
      </div>
    </section>
  );
};

export default Training;
